<template>
  <Stack>
    <Alert v-if="tenant.theme.portal_notification_message" type="info">
      <p class="text-sm text-blue-700" v-html="tenant.theme.portal_notification_message"></p>
    </Alert>

    <LoginManager
      :isCustomerLogin="true"
      :email="email"
      :sso-provider="sso_provider"
      :loginUrl="route('web.customer.login.store')"
      :loginViaVerificationCodeUrl="route('web.customer.login-via-verification-code.store')"
      :registerUrl="route('web.customer.registration.show')"
      :forgotPasswordUrl="route('web.customer.forgot-password.show')"
    />

    <div class="flex justify-between gap-4 content-center">
      <aryeo-link :href="route('web.customer.portal.show')">
        <p class="text-sm font-medium leading-5 text-gray-700 cursor-pointer hover:text-gray-500">
          &larr; Back to Portal Home
        </p>
      </aryeo-link>
      <a v-if="show_admin_login" :href="route('web.company.login.show')">
        <p class="text-xs leading-5 text-gray-500 cursor-pointer hover:text-gray-400">
          Admin Login &nearr;
        </p>
      </a>
    </div>
  </Stack>
</template>

<script>
import { Stack } from '@aryeo/runway'

import { useTenant } from '@/Hooks/Shared/useTenant'

import LoginManager from '@/Components/Shared/Forms/LoginManager.vue'
import Alert from '@/Runway/Alerts/Simple.vue'

import Layout from '@/Layouts/Customer/AuthCustomerLayout.vue'

export default {
  layout: Layout,
}
</script>

<script setup>
defineProps({
  email: {
    type: String,
  },
  sso_provider: {
    type: Object,
  },
  show_admin_login: {
    type: Boolean,
    default: false,
  },
})

const { tenant } = useTenant()
</script>
